<form>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Search By Receipt</h4>

    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" aria-label="Close" (click)="reset()"></button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col col-12 col-md-6">
        <div class="position-relative mb-2">
          <input type="text" required class="textInputLong" name="searchReceiptNum" [(ngModel)]="searchReceiptNum" />
          <span class="highlight"></span>
          <span class="bar barLong"></span>
          <label>Receipt Number</label>
        </div>
      </div>
      <div class="col d-flex justify-content-end mt-0 pt-0">
        <button class="btn btn-primary" (click)="findCustomer(searchReceiptNum)"><i class="fas fa-search"></i> Search</button>
      </div>
    </div>
    <div class="container-fluid p-0" [hidden]="customerList.length <= 0">
      <table mat-table [dataSource]="dataSource" matSort>
        <!-- Name Column -->
        <ng-container matColumnDef="CustomerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Name</th>
          <td mat-cell *matCellDef="let customer" (click)="goToCustomer(customer.CustomerID)">
            {{ customer.Name }}
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="CustomerIC">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer IC</th>
          <td mat-cell *matCellDef="let customer" (click)="goToCustomer(customer.CustomerID)">
            {{ customer.ICNumber }}
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="Status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let customer" (click)="goToCustomer(customer.CustomerID)">
            {{ enums.loanStatusString[customer.Status - 1] }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</form>
